<template>
  <SrpModal :isVisible="isVisible" size="medium" isWithScroll @update:isVisible="emit('update:isVisible', $event)" :isClosable="false">
    <template #header>
      <h1 class="global-h1" style="margin-bottom: 8px">Your Guide to a Successful Visit</h1>
      <span style="color: #5b5b5b; font-family: sans-serif">Watch a few short videos to prepare for your visit.</span>
    </template>
    <template #content="{ scrollToTheTop }">
      <CollabCreatorGuide :firstCollabVideosDone="props.firstCollabVideosDone" @slideChange="scrollToTheTop" @complete="emit('complete')" @videoProgress="v => emit('videoProgress', v)" />
    </template>
  </SrpModal>
</template>

<script setup lang="ts">
import SrpModal from "@components/ui/SrpModal.vue";
import CollabCreatorGuide from "./CollabCreatorGuideVideos.vue";
const props = withDefaults(
  defineProps<{
    isVisible: boolean;
    firstCollabVideosDone: number;
  }>(),
  {
    firstCollabVideosDone: 0,
  }
);
const emit = defineEmits<{
  (e: "update:isVisible", value: boolean): void;
  (e: "complete"): void;
  (e: "videoProgress", videosDone: number): void;
}>();
</script>
